import { useDispatch } from "react-redux";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";

const UIText = {
  "es-CL": { label: "Editar" },
  "en-US": { label: "Edit" },
};

const Edit = (props) => {
  const dispatch = useDispatch()

  const onClick = () => {
    dispatch(
      UIactions.openModal({
        type: "device-edit",
        payload: { devices:[props] },
      })
    );
  };

  return <Button {...{ UIText, onClick }} />;
};

export default Edit;
